import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=22af8ef0&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=22af8ef0&prod&scoped=true&lang=css"
import style1 from "./TemplateEditor.vue?vue&type=style&index=1&id=22af8ef0&prod&lang=css"
import style2 from "./TemplateEditor.vue?vue&type=style&index=2&id=22af8ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af8ef0",
  null
  
)

export default component.exports